// extracted by mini-css-extract-plugin
module.exports = {"chipsList":"chips-list_chipsList__IqQWC","chip":"chips-list_chip__3Y1_K","lineScrollContainer":"chips-list_lineScrollContainer__LIGV5"};